<!-- 使う一覧のPassの右部ステイタス表示 -->
<template>
  <!-- 使用済み -->
  <div
    v-if="props.countDown === '00:00:00:00'"
    class="index-ticket-right button_used"
  >
    <div class="button__text">使用済</div>
  </div>
  <!-- 使用済み -->

  <!-- 期限外 -->
  <div
    v-else-if="props.countDown === null && props.isAvailablePeriod == false"
    class="index-ticket-right button_is_not_in_period"
    @click="goToPass()"
  >
    <div class="button__text">期間外</div>
  </div>
  <!-- 期限外 -->

  <!-- 使用中 -->
  <div
    v-else-if="props.countDown !== null && props.countDown !== '00:00:00:00'"
    class="index-ticket-right button_valid"
    @click="goToPass()"
  >
    <div class="button__text">使用中</div>
  </div>
  <!-- 使用中 -->

  <!-- 使う -->
  <div
    v-else-if="props.countDown === null && props.isAvailablePeriod === true"
    class="index-ticket-right"
    @click="onTapUse()"
  >
    <div class="button__text">使う</div>
  </div>
  <!-- 使う -->
</template>

<script>
import { ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";
import passService from "@/services/pass";

export default {
  name: "PUseStatusButton",
  props: {
    bookGroup: {
      type: Object,
      required: true,
    },
    pass: {
      type: Object,
      required: true,
    },
    isAvailablePeriod: {
      type: Boolean,
      required: true,
    },
    countDown: {
      type: String,
      default: null,
      // required: trueにすると、nullの場合warning出るので書かない。でも必須
    },
  },
  setup(props) {
    const isDbsCoupon = ref(false); // DBSのクーポンの場合、使うボタンは表示しないので管理用のフラグ用意

    const onTapUse = () => {

      // 初回タップ時にDBSクーポンかどうかを判定
      const _masterPass = props.bookGroup._master_book.passes.find(
        (e) => e.id == props.pass.master_pass_id
      );
      isDbsCoupon.value = passService.checkIsDbsCoupon(_masterPass);

      if (isDbsCoupon.value) {
        // DBSタブに遷移
        nativeHandlerService.goToDbsTabTop();
      } else {
        goToPass();
      }
    };

    const goToPass = () => {
      var passIds = [];
      var masterPassID = null;

      props.bookGroup.books.forEach(function (_book) {
        _book.passes.forEach(function (passEach) {
          if (props.pass.master_pass_id == passEach.master_pass_id) {
            passIds.push(passEach.id);
            masterPassID = passEach.master_pass_id;
          }
        });
      });

      if (process.env.NODE_ENV == "local") {
        window.location.href = `http://${window.location.host}/#/my-tickets/ticketing/${props.bookGroup.id}/master-pass/${masterPassID}/pass/${passIds}`;
      } else {
        nativeHandlerService.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${props.bookGroup.id}/master-pass/${masterPassID}/pass/${passIds}`
        );
      }
    };

    return {
      onTapUse,
      goToPass,
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
.index-ticket-right {
  height: 51px;
  width: calc(23% - 4% - 1px);
  float: left;
  border-left: 1px dashed #d7d7d7;
  position: relative;
  border-radius: 0px 0px 5px 0px;
}

@media screen and (min-width: 421px) {
  .index-ticket-right {
    height: 12vw;
  }
}

.button_valid {
  color: white;
  background: #f76666;
  margin-top: -1px;
}

.button_is_not_in_period {
  color: #f76666;
  margin-top: -1px;
}

.button_used {
}

.button__text {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 3.5vw;
  font-weight: bold;
}
</style>
